<ng-container [ngSwitch]="column.dataType">
    <ng-container *ngSwitchCase="DATA_TYPE.URL">
        <a
            [href]="value"
            [title]="value"
            class="m-link m-link--heavy"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ value }}
        </a>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.ACTION">
        <span
            *ngIf="!value.isText; else onlyString"
            [title]="value"
            class="m-link m-link--heavy m-link--pseudo-anchor"
            rel="noopener noreferrer"
            (click)="onActionEvent()"
        >
            {{ value.label ?? value }}
        </span>
        <ng-template #onlyString>
            <span [title]="value">
                {{ value.label }}
            </span>
        </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.ACTION_ICON_LIST">
        <ng-container *ngIf="value?.icons; else onlyIcons">
            <ng-container *ngFor="let icon of value.icons">
                <i *ngIf="icon.length" [class]="icon" aria-hidden="true"></i>
            </ng-container>
            <ng-container *ngIf="value.label">
                <span
                    *ngIf="!value.isText; else onlyString"
                    [title]="value.label ?? value"
                    class="m-link m-link--heavy m-link--pseudo-anchor"
                    rel="noopener noreferrer"
                    (click)="onActionEvent()"
                >
                    {{ value.label ?? value }}
                </span>
                <ng-template #onlyString>
                    <span [title]="value.label ?? value">
                        {{ value.label ?? value }}
                    </span>
                </ng-template>
            </ng-container>
        </ng-container>
        <ng-template #onlyIcons>
            <ng-container *ngFor="let icon of value">
                <i *ngIf="icon.length" [class]="icon" aria-hidden="true"></i>
            </ng-container>
        </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.CLIPBOARD">
        <div emmaCopyToClipboard [copyValue]="value">
            {{ value }}
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.LIST">
        <span [title]="cachedTitle">
            {{ cachedValue }}
        </span>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.LIST_LENGTH">
        <span [title]="cachedTitle">
            {{ cachedValue | formatNumber }}
        </span>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.NUMBER">
        {{ value | formatNumber }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.RATIO">
        {{ value | formatNumber }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.PERCENT">
        <span [ngClass]="{ 'm--font-danger': value < 0 }">
            {{ value | formatNumber: '{ "style": "percent" }' }}
        </span>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.CURRENCY">
        {{ cachedValue }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.BOOLEAN">
        <i class="la la-check" *ngIf="value" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.YESNO">
        <i class="la la-check" *ngIf="value" aria-hidden="true"></i>
        <i class="la la-close" *ngIf="!value" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.STARS">
        <i class="la la-star" *ngIf="value >= 1" aria-hidden="true"></i>
        <i class="la la-star-o" *ngIf="value < 1" aria-hidden="true"></i>
        <i class="la la-star" *ngIf="value >= 2" aria-hidden="true"></i>
        <i class="la la-star-o" *ngIf="value < 2" aria-hidden="true"></i>
        <i class="la la-star" *ngIf="value >= 3" aria-hidden="true"></i>
        <i class="la la-star-o" *ngIf="value < 3" aria-hidden="true"></i>
        <i class="la la-star" *ngIf="value >= 4" aria-hidden="true"></i>
        <i class="la la-star-o" *ngIf="value < 4" aria-hidden="true"></i>
        <i class="la la-star" *ngIf="value >= 5" aria-hidden="true"></i>
        <i class="la la-star-o" *ngIf="value < 5" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.TIME_WINDOW">
        {{ cachedValue }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.PARAMS">
        <pre>{{ cachedValue }}</pre>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.STRING">
        <span [title]="cachedTitle">
            {{ cachedValue | formatString }}
        </span>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.DATE">
        {{ cachedValue }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.HTML">
        <span [title]="cachedTitle" [innerHTML]="value"></span>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.ICON">
        <i *ngIf="value" [class]="value" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.ICON_LIST">
        <ng-container *ngIf="value?.icons; else onlyIcons">
            <ng-container *ngFor="let icon of value.icons">
                <i *ngIf="icon.length" [class]="icon" aria-hidden="true"></i>
            </ng-container>
            <ng-container *ngIf="value.label">
                <span>{{ value.label }}</span>
            </ng-container>
        </ng-container>
        <ng-template #onlyIcons>
            <ng-container *ngFor="let icon of value">
                <i *ngIf="icon.length" [class]="icon" aria-hidden="true"></i>
            </ng-container>
        </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.OPTION">
        {{ cachedValue }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.ICON_OPTION">
        <i *ngIf="cachedValue" [class]="cachedValue" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.OPTION_LIST">
        {{ cachedValue }}
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.QR_CODE">
        <a
            *ngIf="value"
            [href]="cachedValue"
            [download]="value + '__qr.png' | formatFilename"
            class="qrLinkContainer"
            ngbPopover="Descargar código QR"
            i18n-ngbPopover
        >
            <qrcode
                #QR
                class="qrcode-fluid-width qrcode-table-preview"
                [qrdata]="value"
                [width]="256"
                [elementType]="'img'"
                [attr.title]="value"
                [errorCorrectionLevel]="'Q'"
            ></qrcode>
        </a>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.PRIORITY">
        <emma-table-row-cell-priority
            [value]="cachedValue"
            [title]="cachedTitle"
            [isEditable]="isEditable"
            ($priorityChange)="onActionEvent($event)"
        ></emma-table-row-cell-priority>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.PERCENTAGE_VALUE">
        <div class="d-flex flex-column align-items-center" *ngIf="value" [attr.title]="value.tooltip || null">
            <span
              *ngIf="value.percentage !== null"
              class="badge d-inline-block {{ getPercentageBadgeClass(value) }}"
              style="--bs-bg-opacity: .15; --bs-text-opacity: 0.8;"
            >
              {{ (value.percentage * 100) | number: '1.0-2' }}%
            </span>
            <small class="text-center m--margin-top-5">
              {{ value.type === DATA_TYPE.CURRENCY ? (value.value | currency : this.column.unit : 'symbol-narrow': '1.0-2') : (value.value | number) }}
          </small>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="DATA_TYPE.TAGS">
      <div class="d-flex flex-row flex-wrap align-items-center gap-1" *ngIf="value">
        @if (isArray(value)) {
          @for (tag of value; track tag.name) {
            <span class="m-tag m-tag--altdarkblue" [title]="tag.name">
              {{ tag.name }}
            </span>
          }
        } @else {
          <span class="m-tag m-tag--altdarkblue" [title]="value.name">
            {{ value.name }}
          </span>
        }
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <span [title]="value">{{ value }}</span>
    </ng-container>
</ng-container>
